import React, { Component } from "react";

import { Link } from "react-router-dom";
import Loader from "react-loader";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      licenseTypes: [],
      subLicenseTypes: [],
      topLevelFilteredLicenseTypes: [],
      subLevelFilteredLicenseTypes: [],
      filteredStates: [],
      licenseTypeID: 1,
      isActive: false,
      activeIndex: 1,
      selectedUSState: undefined,
      loaded: false
    };
  }
  componentWillMount() {
    let id = this.state.licenseTypeID;
    fetch(`${process.env.REACT_APP_API_URL}/api/licensing/${id}/questions`)
      .then(function (response) {
        // console.log(response)
        return response.json();
      })
      .then(data => {
        // console.log(data);

        let topLevelFilteredLicenseTypes = this.state
          .topLevelFilteredLicenseTypes;
        let subLevelFilteredLicenseTypes = this.state
          .subLevelFilteredLicenseTypes;
        //setting the top level license types
        topLevelFilteredLicenseTypes = data.LicenseTypes.filter(
          i => !i.LicenseType.includes("Psychological Associate")
        );
        // console.log(topLevelLicenseTypes);
        this.setState({
          licenseTypes: topLevelFilteredLicenseTypes,
          loaded: true
        });
        //creating a new Psychological Associate Menu License Type
        topLevelFilteredLicenseTypes = topLevelFilteredLicenseTypes.push({
          LicenseType: "Psychological Associate",
          Id: -1
        });

        //setting the sub level license types
        subLevelFilteredLicenseTypes = data.LicenseTypes.filter(i =>
          i.LicenseType.includes("Psychological Associate")
        );
        // console.log(subLevelFilteredLicenseTypes)
        this.setState({
          subLicenseTypes: subLevelFilteredLicenseTypes
        });
      })
      .catch(function(error) {
        console.log(error);
      });
    // let id = this.state.licenseTypeID;
    this.fetchJurisdictions();
  }

  render() {
    return (
      <div>
        {/* ---------Header Section ---------------*/}
        <div className="header">
          <h4>
            ASPPB PSY<span className="psy-book-divide">|</span>Book:{" "}
            <span> Psychology Licensing Requirements</span>
          </h4>
          <div className="header-subtext">
            <div className="welcome">Welcome to ASPPB’s PSY|Book!</div>You may
            remember this as the ASPPB Handbook on Licensing and Certification
            Requirements but now with a new look. This resource contains the
            basic information for licensure of psychologists in the United
            States and Canada. All information contained in this database was
            collected directly from our membership of psychology licensing
            boards and is provided to PSY|Book users by ASPPB for reference
            purposes. The information provided in PSY|Book is subject to change
            at any time. For the most current licensing requirements, please
            contact the licensing board directly. If you have specific questions
            or concerns regarding licensure, please contact your board of
            psychology directly. Let’s get started!
          </div>
        </div>
        {/* -----------Nav Section -------------------*/}
        <div className="step-one">Step 1: Select a View</div>
        <div className="nav-wrapper">
          <div>
            <Link
              className={
                this.props.activeMapLink ? "active-link" : "inactive-link"
              }
              to="/"
            >
              Map View
            </Link>
          </div>
          <div>
            <Link
              className={
                this.props.activeListLink ? "active-link" : "inactive-link"
              }
              to="/detail-view"
            >
              List View
            </Link>
          </div>
        </div>
        {/*--------- End of Nav Section --------------*/}
        {/* ----------License Type Section----------- */}
        <div className="step-one">
          Step 2: Select a License Type you want to learn more about.
        </div>
        <Loader loaded={this.state.loaded}>
          <div className="row license-type-wrapper">
            {this.state.licenseTypes.map((type, key) => (
              <div
                onClick={this.props.handleLicenseTypeChange}
                id={type.Id}
                key={type.Id}
                className={
                  this.props.activeIndex === type.Id
                    ? "active license-type"
                    : "not-active license-type"
                }
              >
                {type.LicenseType}
              </div>
            ))}
              {this.props.openSubHeader ? (
                <div className="row sub-header">
                  {this.state.subLicenseTypes.map((type, key) => (
                    <div
                      onClick={this.props.handleLicenseTypeChange}
                      id={type.Id}
                      key={type.Id}
                      className={
                        this.props.activeIndex === type.Id
                          ? "active license-type"
                          : "not-active license-type"
                      }
                    >
                      {type.LicenseType}
                    </div>
                  ))}
                </div>
              ) : null}
          </div>
        </Loader>
        {/* --------End of License Type Section----------- */}
        {/*--------- End of Header Section ----------------*/}
      </div>
    );
  }
  fetchJurisdictions() {
    fetch(`${process.env.REACT_APP_API_URL}/api/licensing/jurisdictions`)
      .then(function (response) {
        return response.json();
      })
      .then(data => {
        // console.log(data);
        // this.setState({
        //   data: data
        // })
      })
      .catch(function(error) {
        console.log(error);
      });
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js